'use client';

import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { clsx } from "clsx";
import React, { useState } from "react";

export const usePopOver = () => {
  const [open, setOpen] = useState(false);
  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  return { open, show, hide };
}

export function PopOver({ children, content, open, onMouseEnter, onMouseLeave, onClick, className, buttonClassName }: React.PropsWithChildren<{
  content:          string,
  open:             boolean,
  onMouseEnter?:    (_: React.MouseEvent) => void,
  onMouseLeave?:    (_: React.MouseEvent) => void,
  onClick?:         (_: React.MouseEvent) => void,
  className?:       string,
  buttonClassName?: string,
}>) {
  return (
    <Popover as="div" className={clsx(`flex flex-col items-center`, className)}>
      <PopoverButton as="div" className={clsx(`flex items-center outline-none`, buttonClassName)} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onClick}>
        {children}
      </PopoverButton>
      { open && <PopoverPanel static role="tooltip" className="transform -translate-y-12 whitespace-nowrap absolute z-50 bg-gray-700 rounded-lg text-white px-3 py-2 text-sm font-normal inline-block ring-1 ring-black/5 focus:outline-none after:content-[''] after:absolute after:-z-10 after:w-0 after:h-0 after:border-[1rem] after:border-gray-700 after:-bottom-1 after:left-1/2 after:-translate-x-1/2 after:rotate-45">
        {content}
      </PopoverPanel> }
    </Popover>
  );
}
